<script setup> 
import PremiumPageHeader from '@/Components/PremiumPageHeader.vue';
import { ref } from "vue";
import BreezeAuthenticatedLayout from '@/Layouts/Authenticated.vue';
import { Link, Head } from '@inertiajs/inertia-vue3';
import BaseButton from "@/Components/BaseButton.vue";
import { mdiPlusCircle } from "@mdi/js";
import CardBox from "@/Components/CardBox.vue";
import TableSingle from "@/Components/TableSingle.vue";
import CardBoxComponentRestricted from '@/Components/CardBoxComponentRestricted.vue';

defineProps({
    canRead: Boolean,
    canWrite: Boolean,
    canDelete: Boolean,
    helps: Array,
    //select_level: Array
});
const rutaprefijo = ref('help');
const modulo = ref('ayuda');
</script>

<template>

    <Head title="Áreas curriculares" />

    <BreezeAuthenticatedLayout>

        <template #header>
        <PremiumPageHeader :icon="mdiCog" title="Ayuda" subtitle="Gestión de ayuda">
        </PremiumPageHeader>
    </template>

        <div>
            <div class="bg-white overflow-hidden border rounded-md shadow-lg p-4">

                <!--<div v-for="user in users" :key="user.id">
                            <Link :href="`/users/${user.id}`">
                                {{ user.user}}
                            </Link>
                            <div>{{ user.name}}</div>
                        </div>-->
                <CardBox v-if="canRead" has-table>
                    <!-- Tablesingle opciones: checkable isRef ya está por defecto en modulo Nivel -->
                    <TableSingle :modulo="modulo" :data="helps" :ruta="rutaprefijo" />
                </CardBox>
                <CardBox v-else>
                    <CardBoxComponentRestricted />
                </CardBox>
            </div>
        </div>
    </BreezeAuthenticatedLayout>
</template>
